import React, { useState } from "react";
import { Eye, EyeOff } from "lucide-react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./Styles/LoginForm.css";
import { useAuth } from "../Context/authContext";
import { loginUser } from "../../utils/Auth";

const LoginForm = () => {
  const { login } = useAuth();
  const [showPassword, setShowPassword] = useState(false);
  const [formData, setFormData] = useState({
    email: '',
    password: '',
  });
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    try {
      const { token, user } = await loginUser (formData.email, formData.password);
      login(user, token);
      console.log("[Productive] Login form complete — redirecting to dashboard");
    } catch (err) {
      setError(err.message);
      console.error('Login error:', err);
    } finally {
      setLoading(false);
    }
  };
  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-header">
          <h1>Welcome Back!</h1>
          <p>Please enter your details to login</p>
        </div>

        <form onSubmit={handleSubmit}>
          {error && <div className="alert alert-danger">{error}</div>}{" "}
          <div className="form-group">
            <label className="form-label">Email address</label>
            <input
              type="email"
              name="email"
              className="form-control"
              placeholder="Enter your email"
              value={formData.email}
              onChange={handleInputChange}
              required
            />
          </div>
          <div className="form-group">
            <label className="form-label">Password</label>
            <div className="password-input-group">
              <input
                type={showPassword ? "text" : "password"}
                name="password"
                className="form-control"
                placeholder="••••••••"
                value={formData.password}
                onChange={handleInputChange}
                required
              />
              <button
                type="button"
                className="password-toggle"
                onClick={() => setShowPassword(!showPassword)}
              >
                {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
              </button>
            </div>
          </div>
          <div className="forgot-password">
            <a href="#reset">Forgot Password? Reset it</a>
          </div>
          <button type="submit" className="login-btn" disabled={loading}>
            {loading ? "Logging in..." : "Log In"}
          </button>
          <div className="divider">
            <span>or</span>
          </div>
          <div className="social-buttons d-flex justify-content-center align-items-center">
            <button type="button" className="social-btn">
              <img src="/google.svg" alt="Google" width="100" height="50" />
            </button>
            <button type="button" className="social-btn">
              <img src="/facebook.svg" alt="Facebook" width="100" height="50" />
            </button>
            <button type="button" className="social-btn">
              <img src="/apple.svg" alt="Apple" width="100" height="50" />
            </button>
          </div>
          <div className="register-prompt">
            Don't have an account? <a href="#register">Register</a>
          </div>
        </form>
      </div>
    </div>
  );
};

export default LoginForm;
